<div class="treatment-date-cell">
  <div class="flex-{{ direction }}-container gap-{{ direction === 'column' ? '7' : '15' }}">
    @if (operationDate) {
    <div class="flex-center gap-5">
      @if (operationDateLink) {
      <a [routerLink]="operationDateLink.route" [queryParams]="operationDateLink.params">
        <span>
          {{ operationDate }}
        </span>
      </a>
      } @if (!operationDateLink) {
      <span> {{ operationDate }}</span>
      }
    </div>
    } @if (createDate) {
    <div class="gap-5">
      <mat-icon svgIcon="creation-date"></mat-icon>
      @if (createDateLink) {
      <a [routerLink]="createDateLink.route" [queryParams]="createDateLink.params">
        <span>
          {{ createDate }}
        </span>
      </a>
      } @if (!createDateLink) {
      <span> {{ createDate }}</span>
      }
    </div>
    } @if (submitDate) {
    <div class="gap-5">
      <mat-icon svgIcon="submission-date"></mat-icon>
      <span>
        {{ submitDate }}
      </span>
    </div>
    }
  </div>
</div>
